enum MFA_METHODS_ENUM {
	WEBAUTHN = 'webauthn',
	SMS = 'sms',
	EMAIL = 'email',
	TOTP = 'totp',
}

export default MFA_METHODS_ENUM;
